import { getFormattedDate } from "utils/date";
import { getMappedBillingCode } from "utils/billingCode.util";

export const APP_ENV = process.env.REACT_APP_ENV;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL;

export const SOCKET_SERVER_NAMESPACES = {
  REPORT_PRESENCE: "reportPresence",
  TRANSCRIBE: "transcribe",
  NOTIFICATIONS: "notifications",
};

export const SOCKET_SERVER_URLS = {
  [SOCKET_SERVER_NAMESPACES.REPORT_PRESENCE]: `${SOCKET_SERVER_URL}/${SOCKET_SERVER_NAMESPACES.REPORT_PRESENCE}`,
  [SOCKET_SERVER_NAMESPACES.TRANSCRIBE]: `${SOCKET_SERVER_URL}/${SOCKET_SERVER_NAMESPACES.TRANSCRIBE}`,
  [SOCKET_SERVER_NAMESPACES.NOTIFICATIONS]: `${SOCKET_SERVER_URL}/${SOCKET_SERVER_NAMESPACES.NOTIFICATIONS}`,
};

export const WEBSOCKET_ENABLED_ENVS = ["prod", "pre"];

export const SESSION_BLOCKED_CODES = ["ACCOUNT_DEACTIVATED", "ACCOUNT_LOCKED"];

export const SESSION_EXPIRY_BROADCAST_KEY = "SESSION_EXPIRY_BROADCAST";

export const SESSION_EXPIRY_WARNING_TIME_MS = 5 * 60 * 1000;

export const MAX_SAFE_SETTIMEOUT_DELAY_MS = 2147483647;

export const RESET_APP_STATE = "RESET_APP_STATE";

export const RPM_CONNECTIVITY_SIGNAL_STRENGTH_THRESHOLD = 50;

export const PHONE_NUMBER_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const CUSTOM_NOTES = "Custom Notes";

export const EVOKE_AUTOMATED_NOTES = "EVOKE AUTOMATED NOTES";

export const REPORT_SEVERITY = ["None", "Critical", "Warning"];
export const REPORT_SEVERITY_MAP = {
  None: "#4CAF50",
  Critical: "#da4844",
  Warning: "#ed9040",
};

export const REPORT_ALERT_SEVERITY_MAP = {
  None: {
    color: "green",
    priority: 0,
  },
  Warning: {
    color: "yellow",
    priority: 1,
  },
  Critical: {
    color: "red",
    priority: 2,
  },
};

export const REPORT_SEVERITY_OPTIONS = ["All", "Critical", "Warning"];

export const TASK_TAB_VIEW_MAPPER = {
  active: "Active Tasks",
  automated: "Automated Scheduled Tasks",
  archived: "Archived Tasks",
};

export const SETTINGS_TAB_VIEW_MAPPER = {
  users: "Users",
  devices: "Device Configuration",
  manufacturerAccount: "Manufacturer Configuration",
  "quick-text-templates": "Quick Text Templates",
};

export const BILLING_TAB_VIEW_MAPPER = {
  insurances: "Insurances",
  "referring-providers": "Referring Providers",
};

export const TEMPLATES_TAB_VIEW_MAPPER = {
  templates: "Report Templates",
  notes: "Report Notes",
  "device-groups": "Device Groups",
};

export const ALERT_STATUS_MAP = {
  Warning: {
    alert: "Critical",
    none: "None",
  },
  Critical: {
    attention: "Warning",
    none: "None",
  },
};

export const TASK_STATUS_OPTIONS = [
  { value: "To Do", label: "To Do", color: "yellow" },
  { value: "In Progress", label: "In Progress", color: "blue" },
  { value: "Blocked", label: "Blocked", color: "red" },
  { value: "Complete", label: "Complete", color: "green" },
];

export const TASK_STATUS_OPTIONS_COLOR_MAP = {
  "To Do": "yellow",
  "In Progress": "blue",
  Blocked: "red",
  Complete: "green",
};

export const TASK_STATUS_COLOR_MAP = {
  "To Do": "#FF9800",
  "In Progress": "#175EC8",
  Blocked: "#EF5350",
  Complete: "#4CAF50",
};

// TODO: combine BILLING_CODES and UPDATED_BILLING_CODES after seeding
export const BILLING_CODES = [
  "93294",
  "93295",
  "93296",
  "93297",
  "93298",
  "G2066",
  "0578T",
  "93264",
];

export const UPDATED_BILLING_CODES = [
  "93294",
  "93295",
  "93296",
  "93297 26",
  "93298 26",
  "G2066",
  "0578T",
  "93264",
];

export const BILLING_SCHEDULE_CODES = [
  "93294",
  "93295",
  "93297",
  "93298",
  "0578T",
  "93264",
];

export const HF_BILLING_CODES = ["93297", "93297 26"];
export const ILR_BILLING_CODES = ["93298", "93298 26"];
export const RPM_BILLING_CODES = ["99453", "99454", "99457", "99458"];
export const DIAGNOSIS_CODES = ["Z45.018", "Z95.810", "R00.2", "I49.5", "R55"];

export const RPM_BILLING_CODES_OPTIONS = [
  "99445",
  "99453",
  "99454",
  "99457",
  "99458",
  "99458 * 2",
  "99458 * 3",
  "99470",
];

export const DIAGNOSIS_CODES_BY_RPM_BILLING_CODES = {
  99445: ["Z01.30"],
  99453: ["Z01.30"],
  99454: ["Z01.30"],
  99457: ["Z01.30"],
  99458: ["Z01.30"],
  "99458 * 2": ["Z01.30"],
  "99458 * 3": ["Z01.30"],
  99470: ["Z01.30"],
};

export const REMOTE_DIAGNOSIS_CODES_BY_NEW_BILLING_CODES = {
  93294: ["Z45.018", "I49.5"],
  93295: ["Z95.810"],
  93296: ["Z45.018", "Z95.810"],
  "93297 26": [
    "Z45.018",
    "Z95.810",
    "I25.5",
    "I42.0",
    "I42.1",
    "I42.2",
    "I42.8",
    "I45.89",
  ],
  "93298 26": ["R00.2", "R55", "I48.91"],
  G2066: ["Z45.018", "Z95.810", "R00.2"],
  "0578T": ["I47.20"],
  93264: ["I50.9"],
};

export const REMOTE_DIAGNOSIS_CODES_BY_OLD_BILLING_CODES = {
  93294: ["Z45.018", "I49.5"],
  93295: ["Z95.810"],
  93296: ["Z45.018", "Z95.810"],
  93297: [
    "Z45.018",
    "Z95.810",
    "I25.5",
    "I42.0",
    "I42.1",
    "I42.2",
    "I42.8",
    "I45.89",
  ],
  93298: ["R00.2", "R55", "I48.91"],
  G2066: ["Z45.018", "Z95.810", "R00.2"],
  "0578T": ["I47.20"],
  93264: ["I50.9"],
};

export const ADDITIONAL_BILLING_CODES = {
  93294: ["93296"],
  93295: ["93296"],
};

export const BILLING_TYPE = {
  IDTF: "IDTF",
  INVOICE: "INVOICE",
  SPLIT: "SPLIT",
};

export const BILLING_CODES_MAPPER = {
  93294: 93294,
  93295: 93295,
  93296: 93296,
  93297: "93297 26",
  93298: "93298 26",
  "93297 26": "93297 26",
  "93298 26": "93298 26",
  G2066: "G2066",
  "0578T": "0578T",
  93264: "93264",
};

export const OLD_BILLING_CODES_MAPPER = {
  93294: "93294",
  93295: "93295",
  93296: "93296",
  93297: "93297",
  93298: "93298",
  "93297 26": "93297",
  "93298 26": "93298",
  G2066: "G2066",
  "0578T": "0578T",
  93264: "93264",
};

export const IN_OFFICE_DIAGNOSIS_CODES_BY_BILLING_CODES = {
  93260: [
    "I42.0",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93261: [
    "Z95.810",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93279: [
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93280: [
    "I49.5",
    "I44.1",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93281: [
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93282: [
    "I42",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.5",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93283: [
    "I42",
    "I42.1",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
    "I25.5",
  ],
  93284: [
    "I42",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93285: [
    "Z45.09",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93288: [
    "I42.0",
    "Z45.018",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93289: [
    "I42.0",
    "Z95.810",
    "I49.5",
    "I42",
    "Z45.09",
    "Z45.018",
    "Z95.0",
    "R00.2",
    "I44.2",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "I47.2",
    "I49.01",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93290: [
    "I49.5",
    "Z95.0",
    "I44.2",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  93291: [
    "R00.2",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93279 26": [
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93280 26": [
    "I49.5",
    "I44.1",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93281 26": [
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93282 26": [
    "I42",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.5",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93283 26": [
    "I42",
    "I42.1",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
    "I25.5",
  ],
  "93284 26": [
    "I42",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93285 26": [
    "Z45.09",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "93290 26": [
    "I49.5",
    "Z95.0",
    "I44.2",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "0804T": [
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I47.2",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
  "0575T": [
    "I47.2",
    "I49.1",
    "I49.2",
    "Z86.79",
    "I42",
    "I49.5",
    "I44.2",
    "Z95.0",
    "I48.0",
    "I48.91",
    "I44.1",
    "R00.1",
    "I49.9",
    "I42.9",
    "I50.22",
    "Z95.810",
    "I49.01",
    "I42.0",
    "I42.8",
    "I46.9",
    "I25.10",
    "R55",
    "I63.9",
    "R00.2",
    "R42",
    "I47.1",
    "R06.02",
  ],
};

export const DAY31_BILLING_CODE_OPTIONS = ["93297 26", "93298 26", "93264"];
export const DAY91_BILLING_CODE_OPTIONS = ["93294", "93295", "0578T"];

export const BILLING_CODE_DESCRIPTION_MAP = {
  93260: "Programming device evaluation (implanted system)",
  93261: "Interrogate subcutaneous defibrillator",
  93279: "Programming device evaluation (PM/LDLs PM)",
  93280: "Pacemaker device programming evaluation (dual)",
  93281: "Pacemaker device programming evaluation (multi)",
  93282: "ICD Single Lead Evaluation/Programming",
  93283: "ICD Dual Lead Evaluation/Programming",
  93284: "ICD Multi-Lead Evaluation/Programming",
  93285: "Implantable Loop Recorder Evaluation/Programming",
  93286: "Pacemaker Evaluation & Programming",
  93287: "ICD Evaluation & Programming",
  93288: "Interrogation evaluation (PM/LDLs PM, IP)",
  93289: "Interrogation/EvaI ICD In Person",
  93290:
    "In person interrogation of implantable cardiovascular physiologic monitor system",
  93291: "In-Person Loop Recorder Interrogation",
  93296: "Remote Pacemaker/ICD Interrogation",
  "93279 26": "Programming device evaluation (PM/LDLs PM)",
  "93280 26": "Pacemaker device programming evaluation (dual)",
  "93281 26": "Pacemaker device programming evaluation (multi)",
  "93282 26": "ICD Single Lead Evaluation/Programming",
  "93283 26": "ICD Dual Lead Evaluation/Programming",
  "93284 26": "ICD Multi-Lead Evaluation/Programming",
  "93285 26": "Implantable Loop Recorder Evaluation/Programming",
  "93290 26":
    "In person interrogation of implantable cardiovascular physiologic monitor system",
  "0804T": "Leadless pacemaker dual-chamber programming evaluation",
  "0575T":
    "In-person programming evaluation of an implantable cardioverter-defibrillator (ICD) with a substernal electrode",
};

export const DIAGNOSIS_CODE_DESCRIPTION_MAP = {
  "I49.5": "Sick sinus syndrome",
  "I44.2": "Atrioventricular block, complete",
  "Z95.0": "Presence of cardiac pacemaker",
  "I48.0": "Paroxysmal atrial fibrillation",
  "I48.91": "Unspecified atrial fibrillation",
  "I44.1": "Atrioventricular block, second degree",
  "R00.1": "Bradycardia, unspecified",
  "I49.9": "Cardiac arrhythmia, unspecified",
  "I42.9": "Cardiomyopathy, unspecified",
  "I50.22": "Chronic systolic (congestive) heart failure",
  "Z95.810": "Presence of automatic (implantable) cardiac defibrillator",
  "I47.2": "Ventricular tachycardia, unspecified",
  "I49.01": "Ventricular fibrillation",
  "I42.0": "Dilated cardiomyopathy",
  "I42.8": "Other cardiomyopathies",
  "I46.9": "Cardiac arrest, cause unspecified",
  "I25.10":
    "Atherosclerotic heart disease of native coronary artery without angina pectoris",
  R55: "Syncope and collapse",
  "I63.9": "Cerebral infarction, unspecified",
  "R00.2": "Palpitations",
  R42: "Dizziness and giddiness",
  "I47.1": "Supraventricular tachycardia, unspecified",
  "R06.02": "Shortness of breath",
  "I25.5": "Ischemic cardiomyopathy",
};

export const getDay31BillingCodes = (isIDTFBilling = false) => {
  return DAY31_BILLING_CODE_OPTIONS?.map((code) =>
    getMappedBillingCode({ billingCode: code, isIDTFBilling })
  );
};

export const getCustomBillingCodes = (isIDTFBilling = false) => {
  return [
    ...getDay31BillingCodes(isIDTFBilling),
    ...DAY91_BILLING_CODE_OPTIONS,
  ];
};

export const TOAST_AUTO_HIDE_TIME = 2000;
export const TOAST_POSITION = "top-right";
export const TOAST_CONFIG = {
  autoClose: TOAST_AUTO_HIDE_TIME,
  position: TOAST_POSITION,
  hideProgressBar: true,
  minHeight: "75px",
};
export const TOAST_SEVERITY = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const USER_ROLES = {
  ADMIN: "admin",
  ASSISTANT: "assistant",
  USER: "user",
  CLINIC: "clinic",
  CLINIC_REVIEWER: "clinicReviewer",
  PHYSICIAN: "physician",
  CLINIC_ADMIN: "clinicAdmin",
  RPM_USER: "rpmUser",
};

// Roles that can hold the assigned-hospital restriction. Its control is hidden for the
// rest, so changing a restricted user to one of those is refused.
// Chosen in a hospital filter to include patients with no hospital recorded.
// Must match the sentinel the API expects.
export const HOSPITAL_UNASSIGNED = "__unassigned_hospital__";

// Matches no hospital, so an empty selection returns no rows. Must match the API's.
export const HOSPITAL_NO_MATCH = "__no_matching_hospital__";

export const HOSPITAL_RESTRICTED_ROLES = [
  USER_ROLES.CLINIC,
  USER_ROLES.PHYSICIAN,
];

export const USER_ROLE_MAPPER = {
  [USER_ROLES.ADMIN]: "Admin",
  [USER_ROLES.ASSISTANT]: "Assistant",
  [USER_ROLES.USER]: "User",
  [USER_ROLES.CLINIC]: "Clinic",
  [USER_ROLES.CLINIC_ADMIN]: "Clinic Admin",
  [USER_ROLES.PHYSICIAN]: "Physician",
  [USER_ROLES.CLINIC_REVIEWER]: "Clinic Reviewer",
  [USER_ROLES.RPM_USER]: "RPM User",
};

export const EVOKE_ROLES = [
  USER_ROLES.USER,
  USER_ROLES.ADMIN,
  USER_ROLES.ASSISTANT,
];

export const CLINIC_ROLES = [
  USER_ROLES.CLINIC,
  USER_ROLES.PHYSICIAN,
  // USER_ROLES.CLINIC_REVIEWER,
  USER_ROLES.CLINIC_ADMIN,
];

export const ROLES = [...EVOKE_ROLES, ...CLINIC_ROLES, USER_ROLES.RPM_USER];

export const CLINIC_NAMES = {
  CENTRA: "Centra",
  CENTRA_HF: "Centra Heart Failure",
  DENVER_HEART: "Denver Heart",
  BAPTIST_HV_EP: "Baptist Heart & Vascular Electrophysiology",
  MIAMI: "Miami Cardiac & Vascular Institute",
  UCH_SOUTH: "UCHealth South",
  UCH_METRO: "UCHealth Metro",
  UCH_NORTH: "UCHealth North",
  UCH: "UCH",
  DENVER_HEALTH: "Denver Health",
  PARKWAY: "Parkway Cardiology Associates",
  CAET: "CAET",
  KNOXVILLE: "Knoxville Heart Group",
  PUEBLO: "Pueblo Cardiology Associates",
  CCH: "Campbell County Health Cardiology",
};

export const UCH_CLINICS = [
  CLINIC_NAMES.UCH_NORTH,
  CLINIC_NAMES.UCH_SOUTH,
  CLINIC_NAMES.UCH_METRO,
];

// Denver Heart signs from the clinic note, so Ctrl+Space Sign & Process is off there
export const SIGN_AND_PROCESS_SHORTCUT_EXCLUDED_CLINICS = [
  CLINIC_NAMES.DENVER_HEART,
];

export const FACILITY_MAP = {
  UCH: {
    allAccounts: [
      CLINIC_NAMES.UCH_NORTH,
      CLINIC_NAMES.UCH_SOUTH,
      CLINIC_NAMES.UCH_METRO,
      CLINIC_NAMES.PUEBLO,
      CLINIC_NAMES.CCH,
    ],
    crossFacilityAccessAccounts: [
      CLINIC_NAMES.UCH_NORTH,
      CLINIC_NAMES.UCH_SOUTH,
      CLINIC_NAMES.UCH_METRO,
    ],
  },
};

export const REPORT_ASSIGNMENT_CLINICS = [
  CLINIC_NAMES.CENTRA,
  CLINIC_NAMES.DENVER_HEALTH,
];

export const SEX_ASSIGNED_AT_BIRTH_OPTIONS = [
  { value: "undisclosed", option: "Choose not to disclose" },
  { value: "female", option: "Female" },
  { value: "male", option: "Male" },
  { value: "not-recorded", option: "Not recorded on birth certificate" },
  { value: "uncertain", option: "Uncertain" },
  { value: "unknown", option: "Unknown" },
];

export const GENDER_IDENTITY_OPTIONS = [
  { value: "undisclosed", option: "Choose not to disclose" },
  { value: "female", option: "Female" },
  { value: "male", option: "Male" },
  { value: "non-binary", option: "Non-Binary" },
  { value: "other", option: "Other" },
  { value: "transgender-female", option: "Transgender Female" },
  { value: "transgender-male", option: "Transgender Male" },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: "undisclosed", option: "Choose not to disclose" },
  { value: "married", option: "Married" },
  { value: "single", option: "Single" },
  { value: "divorced", option: "Divorced" },
  { value: "widowed", option: "Widowed" },
  { value: "separated", option: "Separated" },
  { value: "other", option: "Other" },
];

export const GENDER_OPTIONS = [
  { value: "male", option: "Male" },
  { value: "female", option: "Female" },
  { value: "other", option: "Other" },
];

export const CURRENT_YEAR = new Date().getFullYear();

export const RPM_DEVICE_MANUFACTURER = {
  bpCuff: "Evoke BP Cuff",
  holterMonitor: "Evoke Holter Monitor",
  scale: "Evoke Scale",
};

export const RPM_DEVICE_OPTIONS = [
  { key: "body_trace_bp", value: RPM_DEVICE_MANUFACTURER.bpCuff },
  {
    key: "body_trace_holter_monitor",
    value: RPM_DEVICE_MANUFACTURER.holterMonitor,
  },
  { key: "body_trace_scale", value: RPM_DEVICE_MANUFACTURER.scale },
];

export const COMMUNICATION_LOG_MAX_DURATION = 999;

export const bpReadingCommunicationLog = {
  _id: "",
  description: "Viewed RPM Transmission",
  communicated_date: getFormattedDate(new Date(), "MM/DD/YYYY hh:mm:ss A"),
  duration: "2",
  mode: "Other",
  customMode: "Monitoring",
};

export const FILE_CONTENT_TYPE = {
  PDF: "application/pdf",
};

export const DEFAULT_NEXT_TRANSMISSION_CYCLE_DAYS = 31;

export const STROKE_HISTORY_STATUS_COLOR_MAP = {
  yes: "error",
  no: "success",
};

export const ANTICOAGULANT_STATUS_COLOR_MAP = {
  Yes: "success",
  No: "error",
};

export const SUBMIT_ACTIONS = {
  SAVE: "Save",
  ARCHIVE: "Archive",
  PROCESS: "Process",
  UNPROCESS: "Unprocess",
  SAVE_AND_PROCESS: "Save & Process",
  SIGN_AND_PROCESS: "Sign & Process",
  SIGN_AND_UNPROCESS: "Sign & Unprocess",
  SAVE_SIGN_AND_PROCESS: "Save, Sign & Process",
  SAVE_SIGN_AND_UNPROCESS: "Save, Sign & Unprocess",
  UNSIGN: "Unsign",
};

export const CARDIO_CHECKS_CLINIC_NOTE_OPTIONS = [
  "Agree with the preliminary findings as noted.",
  "Agree with preliminary findings noted except for:",
  "AT/AF episode",
  "Brady episode",
  "VT Episode",
  "Tachy episode",
  "Normal rate and rhythm.",
  "Continue to monitor",
  "Key observations are",
  "No significant arrhythmias were detected.",
];

export const COVENANT_CLINIC_NOTE_OPTIONS = {
  "BV ICD":
    "Presenting is , underlying is . Normal device function. History shows . Viewed EGMs show . Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Last echo on file from shows EF . Pt to continue with remote monitoring and yearly OV. Next check in 3mo.",
  "Dual/Single ICD":
    "Presenting is , underlying is. Normal device function. History shows . Viewed EGMS show . Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring and yearly OV. Next scheduled check in 3mo.",
  "Nl BV ICD":
    "Presenting is , underlying is. Normal device function. No atrial arrhythmias recorded. No ventricular arrhythmias. Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Last echo on file from shows EF . Pt to continue with remote monitoring and yearly OV. Next scheduled check in 3mo.",
  "Nl Dual/Single ICD":
    "Presenting is , underlying is . Normal device function. History shows no atrial or ventricular arrhythmias. Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring and yearly OV. Next scheduled f/u in 3mo.",
  "BV Pacer":
    "Normal device function. Presenting is , underlying is . History shows . Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Last echo on file from shows EF . Pt to continue with remote monitoring and yearly OV. Next check in 3mo.",
  "Dual/Single pacer":
    "Presenting is , underlying is . Normal device function. History shows . Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring and yearly OV. Next scheduled check in 6mo.",
  "Nl BV Pacer":
    "Presenting is , underlying is . Normal device function. History shows no significant events. Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Last echo on file from shows EF . Pt to continue with remote monitoring and yearly OV.. Next scheduled check in 3mo.",
  "Nl Dual/Single Pacer":
    "Presenting is , underlying is . Normal device function. No atrial arrhythmias recorded. No ventricular arrhythmias recorded. Normal sensing, thresholds and impedances. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring and yearly OV. Next scheduled check in 6mo",
  "Micra AV":
    "Presenting is . History shows . Normal sensing, thresholds and impedance. Diagnostics show AM/VP % of the time. AV conduction %. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring and yearly OV. Next check in 6mo.",
  SICD: "Presenting is VS rhythm. History shows no events or therapies delivered since last check. Lead impedance OK. Limited data available with this device. There is % of battery remaining. Pt to continue with remote monitoring and yrly OV. Next scheduled check in 6mo.",
  "Nl Loop":
    "Remote Transmission. Battery status good. Presenting is . Normal device function. History shows no new patient or auto activated events. Trend data shows good heart rate variation with rates /min ( 10% of the time). Pt to continue with remote monitoring. Next scheduled check in 3mo.",
  "Wnd check":
    "Pt here post implant. Incision healing well no r/e noted. Surgical adhesive intact.",
  "BS Heart failure":
    "Remote transmission for Heart Failure alert. Transmisson shows elevated Heart Logic index at . Pt reports SOB/missed meds/edema Will continue to monitor.",
  "BS Nl Heart failure":
    "Remote transmission for heart failure. Transmission shows Heart Logic index normal at . Will continue to monitor.",
};

export const MIN_DATE = new Date("1900-01-01");
export const REPORT_MIN_DATE = new Date("2014-01-01");
export const MAX_DATE = new Date("3000-12-31");

export const DEFAULT_DOWNLOADING_TEXT = "Downloading...";

export const POST_GRID_PRINT_MAIL_API_STATUS_DESCRIPTION = {
  Ready: "The letter is ready for printing",
  Printing: "The letter is given to a printer",
  "Processed for delivery":
    "The letter is handed off to the local postal service",
  Completed:
    "The letter is most likely been delivered. Please contact post grid for more details",
  Cancelled: "The letter has been cancelled and will never be sent out",
};

export const POST_GRID_PRINT_MAIL_API_STATUS = {
  ready: "Ready",
  printing: "Printing",
  processed_for_delivery: "Processed for delivery",
  completed: "Completed",
  cancelled: "Cancelled",
  corrected: "Corrected",
  verified: "Verified",
};

export const DEFAULT_MIN_YEAR = 2022;

export const MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH = 8;

export const LEAD_TYPE_OPTIONS = [
  "RA",
  "RV",
  "LV",
  "HIS",
  "LBB",
  "Subcutaneous lead",
];
export const billingCode99458CountMap = {
  99458: 1,
  "99458 * 2": 2,
  "99458 * 3": 3,
};

export const BILLING_CODE_99458_VARIATION_BY_COUNT = {
  1: ["99458"],
  2: ["99458 * 2"],
  3: ["99458 * 3"],
  4: ["99458 * 3", "99458"],
  5: ["99458 * 3", "99458 * 2"],
  6: ["99458 * 3", "99458 * 2", "99458"],
};

export const BILLING_CODE_G2066 = "G2066";
export const BILLING_CODE_99458 = "99458";

export const BILLING_CODES_99458 = Object.keys(billingCode99458CountMap);

export const IN_OFFICE_PATIENT_FOUND =
  "The details for this patient is found. Proceed to upload the existing patient report.";
export const IN_OFFICE_PATIENT_NOT_FOUND =
  "The details for this patient is not found. Proceed to create a new patient and the report.";

export const manufacturerMappings = [
  {
    name: "Abbott",
    folder: "abbott",
  },
  {
    name: "Biotronik",
    folder: "biotronik",
  },
  {
    name: "Medtronic",
    folder: "medtronic",
  },
  {
    name: "Boston Scientific",
    folder: "boston_sci",
  },
  {
    name: "Sorin Group",
    folder: "sorin_group",
  },
  {
    name: "Evoke BP Cuff",
    rpmDevice: true,
    folder: "rpm",
  },
  {
    name: "Evoke Scale",
    rpmDevice: true,
    folder: "rpm",
  },
  {
    name: "Evoke Holter Monitor",
    rpmDevice: true,
    folder: "preventice",
  },
];

export const subscribeSettingMapper = [
  {
    label: "Subscribe for call/sms",
    value: "subscribe",
  },
  {
    label: "Next Send(email/call/sms)",
    value: "next_send",
  },
  {
    label: "First Late Reminder",
    value: "first_call",
  },
  {
    label: "Second Late Reminder",
    value: "second_call",
  },
  {
    label: "Third Late Reminder",
    value: "third_call",
  },
  {
    label: "Letter",
    value: "letter",
  },
];

export const REMINDER_LOG_STATUS_COLOR_MAP = {
  sent: "success",
  verified: "success",
  received: "success",
  accepted: "success",
  completed: "success",
  error: "error",
  failed: "error",
  canceled: "error",
  undelivered: "error",
  busy: "warning",
  queued: "warning",
  corrected: "warning",
  receiving: "warning",
  "no-answer": "warning",
  "in-progress": "warning",
  partially_delivered: "warning",
  "follow up": "warning",
  ready: "info",
  ringing: "info",
  sending: "info",
  scheduled: "info",
  "No Subscription": "default",
};

export const REMINDER_HISTORY_STATUS_MAPPER = {
  Sent: ["completed", "delivered", "received", "sent"],
  Failed: ["undelivered", "cancelled", "busy", "no-answer", "error", "failed"],
  "In-progress": [
    "sending",
    "receiving",
    "accepted",
    "scheduled",
    "ready",
    "partially_delivered",
    "processed_for_delivery",
    "printing",
    "ringing",
    "corrected",
    "verified",
    "in-progress",
    "queued",
  ],
  "Follow Up": ["follow_up"],
};

export const validInOfficeFileExtensions = ["xml", "bnk", "log", "23x"];

export const CHANGE_DEVICE_ALERT =
  "Changing device will deactivate patient's current device.";

export const REMINDER_LOG_TYPE = {
  sms: "SMS",
  phone_call: "Phone Call",
  letter: "Letter",
  error: "Error",
  print_mail: "Print Mail",
  address_verification: "Address Verification",
  "SMS/PHONE CALL": "SMS/PHONE CALL",
};

export const REMINDER_LOG_PHONE_TYPE = {
  mobile: "Mobile",
  landline: "Landline",
  fixedVoip: "Fixed Voip",
  nonFixedVoip: "Non Fixed Voip",
  tollFree: "Toll Free",
};

export const COMMUNICATION_MODES = [
  "Phone Call",
  "Email",
  "SMS",
  "Voicemail",
  "Plan Creation",
];

export const CURRENT_DATE = new Date();
export const EVOKE_ACTIVE = "active";
export const EVOKE_PROCESSED = "processed";

export const CLINIC_ACTIVE = "clinic";
export const CLINIC_FOR_REVIEW = "clinic-review";
export const CLINIC_PROCESSED = "clinic-processed";

export const TRANSMISSION_TAB_COUNT_ACCESS = [
  EVOKE_ACTIVE,
  CLINIC_ACTIVE,
  CLINIC_FOR_REVIEW,
];

export const REPORT_NOTES_EDIT_ACCESS = {
  [EVOKE_ACTIVE]: [USER_ROLES.ADMIN, USER_ROLES.USER],
  [CLINIC_ACTIVE]: [
    USER_ROLES.CLINIC,
    USER_ROLES.PHYSICIAN,
    USER_ROLES.CLINIC_ADMIN,
  ],
};

export const TAB_MAPPER = {
  evk_active: EVOKE_ACTIVE,
  evk_processed: EVOKE_PROCESSED,
  clinic_active: CLINIC_ACTIVE,
  clinic_for_review: CLINIC_FOR_REVIEW,
  clinic_processed: CLINIC_PROCESSED,
};

export const REPORT_STATES_MAPPER = {
  [EVOKE_ACTIVE]: "evk_active",
  [EVOKE_PROCESSED]: "evk_processed",
  [CLINIC_ACTIVE]: "clinic_active",
  [CLINIC_FOR_REVIEW]: "clinic_for_review",
  [CLINIC_PROCESSED]: "clinic_processed",
};

export const EVOKE_REPORT_STATES = [
  REPORT_STATES_MAPPER.active,
  REPORT_STATES_MAPPER.processed,
];

export const CLINIC_REPORT_STATES = [
  REPORT_STATES_MAPPER.clinic,
  REPORT_STATES_MAPPER["clinic-review"],
  REPORT_STATES_MAPPER["clinic-processed"],
];

export const BOOLEAN_VALUE_MAPPER = {
  true: "Yes",
  false: "No",
};

export const getAccountByAlternativeNames = (accountName, accounts) => {
  const foundAccount = accounts.find(
    (account) =>
      account?.name === accountName || account?.facility?.includes(accountName)
  );

  return foundAccount?.name || accountName;
};

export const EXCEL_CONTENT_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheatml.sheet";

export const BILLABLE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const USER_TRANSMISSION_PROGRESS_TITLES = {
  alertReportCount: "Alert Report Count",
  signedReportCount: "Signed Report Count",
  billedReportCount: "Billed Report Count",
  billableReportCount: "Billable Report Count",
  processedReportCount: "Total Processed Report Count",
};

export const USER_TRANSMISSION_PROGRESS_CHART_PALETTE = {
  "Alert Report Count": "#EF5350",
  "Signed Report Count": "#F39C12",
  "Billed Report Count": "#4CAF50",
  "Billable Report Count": "#5489D8",
  "Total Processed Report Count": "#9B59B6",
};

export const MANUFACTURER_MAPPER = {
  Abbott: "abbott",
  Biotronik: "biotronik",
  Medtronic: "medtronic",
  "Boston Scientific": "boston_scientific",
  "Sorin Group": "sorin_group",
};

export const ALERT_NOTIFICATION_PREFERENCES_TABLE_HEADER = [
  "Notification Method",
  "Recipients",
  "Message Content",
  "Include PDF",
  "Active",
  "Actions",
];

export const FREE_TEXT = "Free Text";

export const ALERT_NOTIFICATION_METHODS = {
  email: "Email",
  slack: "Slack",
};

export const ALERT_TYPE = {
  red: "Red Alert",
  yellow: "Yellow Alert",
};

export const ALERT_TYPE_COLOR = {
  red: "#ffebee",
  yellow: "#fff9c4",
};

export const ALERT_NOTIFICATION_TIME_PERIOD = {
  regular: "Regular (7 AM - 5 PM)",
  after_hours: "After Hours (5 PM - 7 AM and Weekends)",
};

export const ALERT_NOTIFICATION_MESSAGE_CONTENT = [
  "Name",
  "DOB",
  "MRN",
  "Manufacturer",
  "Device Type",
  "Alert Type",
  "Alert Description",
  "Free Text",
  "Following Physician",
];

export const ALERT_MESSAGE_CONTENT_LIMIT = 1000;

export const ALERT_NOTIFICATION_DEFAULT_PREFERENCES = [
  {
    alert_type: "red",
    notify_configs: [
      {
        active: false,
        time_period: "regular",
        notification_method: "Email",
        include_transmission_pdf: false,
        recipients: [],
        message_content: [],
      },
      {
        active: false,
        time_period: "after_hours",
        notification_method: "Email",
        include_transmission_pdf: false,
        recipients: [],
        message_content: [],
      },
    ],
  },
  {
    alert_type: "yellow",
    notify_configs: [
      {
        active: false,
        time_period: "regular",
        notification_method: "Email",
        include_transmission_pdf: false,
        recipients: [],
        message_content: [],
      },
      {
        active: false,
        time_period: "after_hours",
        notification_method: "Email",
        include_transmission_pdf: false,
        recipients: [],
        message_content: [],
      },
    ],
  },
];
export const TOP_USER_TRANSMISSION_OFFSET_WIDTH = 154;

export const REPORT_INTERVAL_DAYS_MAPPING = {
  "3 months": 90,
  "6 months": 180,
  "9 months": 270,
  "12 months": 365,
};

export const REPORT_INTERVAL_OPTIONS = [
  "3 months",
  "6 months",
  "9 months",
  "12 months",
];

export const SCHEDULE_TYPE_PAYLOAD_MAPPER = {
  "Day 31": "day_31",
  "Day 91": "day_91",
  "Day Custom": "day_custom",
};

export const SCHEDULE_TYPE_RESPONSE_MAPPER = {
  day_31: "Day 31",
  day_91: "Day 91",
};

export const DEVICE_SUGGESTIONS = [
  "2359-40QC Fortify (TM) DR",
  "3262 Quadra Allure MP(TM) RF",
  "Amplia MRI Quad CRTD DTMB1Q1",
  "1257-40Q Fortify Assura(TM) VR",
  "BIOMONITOR III",
  "LNQ22",
  "M302",
];

export const PATIENT_DEACTIVATE_REASONS = [
  "Deceased",
  "Refused Monitoring",
  "Transferred to Clinic name :",
  "Device reached RRT/EOS",
  "Device Explanted",
  "Hospice",
  "Repeated No-Show",
  "No Longer Monitoring",
  "Insurance Change",
];

export const BENCHMARK_BILLING_CODES = [
  "93294",
  "93295",
  "93297 26",
  "93298 26",
  "0578T",
];

export const UCH_METRO_MESSAGE_CONTENT = [
  "AMC patient: CVC EP DEVICE and CVC EP OP",
  "AMC patient: HF alert to CVC EP OP",
  "AMC patient: high priority to AMC EP APPS, CVC EP OP, patients attending and CVC EP DEVICE",
  "HRH patient: P HRP2 CARD NURSE MA, Allison Percevich, Rebecca Isaacson, James Dillingham and Francisco Soto",
  "HRH patient: high priority to Allison Percevich, Rebecca Isaacson, James Dillingham, Francisco Soto, P HRP2 CARD NURSE MA and patients attending",
];

export const API_STATUS_CODE = {
  SUCCESS: 200,
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
  CREATE: 201,
  UNAUTHORIZED: 401,
  TOO_MANY_REQUESTS: 429,
  UNPROCESSABLE_ENTITY: 422,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  FORBIDDEN: 403,
};

export const DISCONNECTED_MONITOR_DOWNLOAD_TYPES = {
  noShowMasterList: "no_show_master",
  disconnectedMonitorList: "disconnected_monitor",
};

export const BROADCAST_CHANNEL_NAME = "redux_sync";

export const SUBSCRIPTION_DISABLE_TYPE_REASON_MAPPING = [
  {
    type: "Paused",
    reasons: [
      "New equipment ordered",
      "Device change scheduled",
      "In hospital or rehab",
      "Traveling",
      "Moving",
      "Text only if overdue",
      "No-show only if late",
      "Email or text notifications only",
      "Patient device at ERI",
      "Insurance Change",
      "Transferring In",
      "New Patient",
      "Waiting for Transfer",
    ],
  },
  {
    type: "Remove",
    reasons: [
      "Deceased",
      "Not Following",
      "Transferred",
      "Explanted",
      "Device Died",
      "Refused Remotes",
      "In-office Interrogations Only",
      "Patient Opted-Out",
    ],
  },
];

export const SUBSCRIPTION_PAUSE_HISTORY_STATUS = {
  scheduled: "scheduled",
  active: "active",
  completed: "completed",
  resumedEarly: "resumed_early",
  removed: "removed",
  deactivated: "deactivated",
};

export const SUBSCRIPTION_PAUSE_HISTORY_STATUS_CHIP = {
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.scheduled]: {
    label: "Scheduled",
    color: "#822EA0",
  },
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.active]: {
    label: "Active",
    color: "#FF9800",
  },
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.completed]: {
    label: "Completed",
    color: "#4CAF50",
  },
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.resumedEarly]: {
    label: "Resumed Early",
    color: "#175EC8",
  },
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.removed]: {
    label: "Removed",
    color: "#444444",
  },
  [SUBSCRIPTION_PAUSE_HISTORY_STATUS.deactivated]: {
    label: "Deactivated",
    color: "#C62828",
  },
};

export const PREFERRED_LANGUAGE_OPTIONS = [
  { value: "English", option: "English" },
  { value: "Spanish", option: "Spanish" },
  { value: "Russian", option: "Russian" },
  { value: "French", option: "French" },
  { value: "German", option: "German" },
  { value: "Vietnamese", option: "Vietnamese" },
];

export const REMINDER_MAPPER = [
  {
    key: "first_call",
    value: "First Reminder",
  },
  {
    key: "second_call",
    value: "Second Reminder",
  },
  {
    key: "third_call",
    value: "Third Reminder",
  },
  {
    key: "letter",
    value: "Letter",
  },
  {
    key: "live_call",
    value: "Live Call",
  },
];

export const REMINDER_ATTEMPTS_MAPPER = {
  first_call: "first_reminder",
  second_call: "second_reminder",
  third_call: "third_reminder",
  letter: "letter",
  live_call: "live_call",
};

export const REMINDER_STATUS_COLOR_MAPPER = {
  sent: "success",
  "in-progress": "warning",
  failed: "error",
};

export const REMINDER_HISTORY_LETTER_MESSAGE = "No Show Letter has been sent";
export const REMINDER_HISTORY_EMAIL_MESSAGE = "Email reminder has been sent";

export const EHR_STATUS_COLOR_MAP = {
  completed: "#94BA33",
  pending: "#FF9800",
  error: "#f44336",
  timeout: "#9E9E9E",
  not_initiated: "#175EC8",
};

export const EHR_STATUS_TEXT_MAP = {
  completed: "Completed",
  pending: "Pending",
  error: "Error",
  timeout: "Timeout",
  not_applicable: "NA",
  not_initiated: "TBS",
};

export const EHR_CHIP_TOOLTIP_TEXT_MAP = {
  ...EHR_STATUS_TEXT_MAP,
  not_initiated: "To be sent",
  not_applicable: "Not Applicable",
};

export const ROLE_INITIAL_ROUTE = {
  admin: "/transmissions",
  user: "/transmissions",
  assistant: "/tasks",
  clinicAdmin: "/transmissions/clinic",
  clinic: "/transmissions/clinic",
  clinicReviewer: "/transmissions/clinic",
  physician: "/transmissions/clinic-review",
  rpmUser: "/rpm",
};

export const INSURANCE_GENDER_MAP = {
  female: "F",
  male: "M",
  other: "U",
};

export const AUTHORIZATION_CODE_MAX_LENGTH = 30;

export const PATIENT_BULK_UPDATE_MODAL_TITLE = {
  showDeviceAlertModal: "Device Alert",
  showAdvisoryModal: "Advisory Alert",
};

export const PATIENT_BULK_UPDATE_FORM_LABEL_MAPPER = {
  showDeviceAlertModal: {
    active: "Set Device Alert",
    inactive: "Remove Device Alert",
  },
  showAdvisoryModal: {
    active: "Assign Advisory Status",
    inactive: "Remove Advisory Status",
  },
};

export const REMINDER_TYPE_STATUS_MESSAGE_MAP = {
  Sent: "Message Sent",
  Failed: "Message failed to deliver",
  Unknown: "Message failed to deliver",
  "In-progress": "Message sending in progress",
};

export const REMINDER_TYPES = [
  "First Reminder",
  "Second Reminder",
  "Third Reminder",
  "Letter",
];

export const API_BASE_URL_BENCHMARK = "https://pm-web1.benchmark-systems.com";
export const LETTER_STATUS_MESSAGE_MAPPER = {
  cancelled: "The letter has been cancelled and will never be sent out",
};

export const ZOOM_CALL_DEFAULT_MESSAGE = "Call was initiated via Zoom.";
export const ZOOM_CALL_STATUS_SUMMARY_MAP = {
  // ✅ RECEIVED CALLS
  park: "Call was parked after being connected via Zoom.",
  voicemail: "Call reached voicemail successfully via Zoom.",
  "answered by other member":
    "Call was answered by another queue member via Zoom.",
  "call connected": "Call successfully connected with the recipient via Zoom.",

  // ❌ FAILED CALLS
  rejected: "Recipient declined the Zoom call.",
  blocked: "Zoom call was blocked by the recipient.",
  busy: "Call attempt via Zoom failed because the recipient’s line was busy.",
  "no answer": "Recipient did not answer the Zoom call.",
  "call cancel": "Call was canceled before connecting via Zoom.",
  "wrong number":
    "Zoom call failed because the dialed number was invalid or unreachable.",
  "international disabled":
    "Zoom call failed because international calling is disabled.",
  "internal error": "Zoom call could not complete due to a system error.",
  "restricted number": "Zoom call failed as the number is restricted.",
  "could not connect": "Zoom call could not connect with the recipient.",
};
export const ZOOM_CALL_RECEIVED_STATUS = [
  "answered by other member",
  "call connected",
  "park",
  "voicemail",
];

export const REMINDER_NOTES_STATUS_COLOR_MAP = {
  sent: "#94ba33",
  verified: "#94ba33",
  received: "#94ba33",
  accepted: "#94ba33",
  completed: "#94ba33",
  error: "#ff0000",
  failed: "#ff0000",
  canceled: "#ff0000",
  undelivered: "#ff0000",
  busy: "#ff9800",
  queued: "#ff9800",
  corrected: "#ff9800",
  receiving: "#ff9800",
  "no-answer": "#ff9800",
  "in-progress": "#ff9800",
  partially_delivered: "#ff9800",
  ready: "#175EC8",
  ringing: "#175EC8",
  sending: "#175EC8",
  scheduled: "#175EC8",
  "No Subscription": "#9E9E9E",
  "follow up": "#ff9800",
};

export const REMINDER_ATTEMPTS_TYPE = {
  email: "Email",
  phone1: "Phone 1",
  phone2: "Phone 2",
  emergency_contact: "Emergency Contact",
  letter: "Letter",
  unknown: "Unknown",
};

export const LIVE_CALL_STATUS = {
  completed: "completed",
  need_follow_up: "need_follow_up",
  to_do: "todo",
};

export const RN_OBSERVATIONS = [
  "More than usual SOB/DOE?",
  "Weight increase > 3lbs?",
  "More edema (bilateral leg or abdominal)",
  "Run out of CHF meds?",
];

export const RN_OBSERVATIONS_FIELDS = [
  { key: "cardiologist", type: "string", label: "Cardiologist" },
  {
    key: "inform_patient_to_call",
    type: "string",
    label: "Patient informed to call cardiologist",
  },
  {
    key: "sign_out_date",
    type: "date",
    label: "Fax sent & RN-to-RN sign out",
  },
];

export const MIN_ATTEMPTS_FOR_MANUAL_LIVE_CALL_TASK_COMPLETE = 3;

export const REPORT_PRESENCE_SOCKET_HEARTBEAT_INTERVAL = 15000;
export const REMINDER_NOTIFICATION_TYPE = {
  next_send_reminder: "Next Send Reminder",
  late_reminder: "Late Reminder",
  disconnected_monitor_reminder: "Disconnected Monitor Reminder",
};

export const REPORT_NOTE_AUTOMATED_NOTES = {
  Battery: "Longevity or Percentage or Status",
  Sensing: "Sensing Value",
  Threshold: "Amplitude (v), Pulse Width (ms), and Pacing Amplitude (v)",
  "Thoracic Impedance Values":
    "Resistance of the chest cavity to an electrical current",
  "HV Impedance":
    "Electrical resistance between a defibrillation lead coil and the pulse generator",
  Impedance: "Impedance (ohms)",
  "Pacing Percentage": "Pacing (%)",
  Arrhythmias:
    "AF, VT, FVT, VF, NSVT, AT, Pause, Brady, Symptom, SVT, Shock, ATP",
  "PVC Burden": "Premature Ventricular Contraction Percentage",
  Burden: "AF Burden Percentage",
  VP: "Ventricular Pacing",
  "Presenting Rhythm": "Only Hyperlinks",
  Leads: "Only Hyperlinks",
  Mode: "Pacing Mode",
};

export const EXTRACTABLE_ASSOCIATED_NOTES = ["Battery"];
export const EXTRACTABLE_MANUFACTURERS = ["Medtronic"];

export const HL7_RESULT_STATUS = {
  Preliminary: "P",
  Final: "F",
};

export const HL7_EXPORT_STATUS = {
  Completed: "completed",
  Pending: "pending",
  Failed: "error",
  Timeout: "timeout",
};

export const DEFAULT_NOTIFICATION_CHANNEL = {
  sms: true,
  call: true,
  email: true,
  letter: true,
};

export const LETTER_TEMPLATE_STYLE = `body { font-family: Arial, sans-serif } .header { display: flex; align-items: center } .content { max-width: 600px; margin: 0 auto; padding: 20px; font-size: 11pt } .signature { font-weight: bold } .logo-image { height: 40px } .evoke_address_section { line-height: 0.3 } .evoke-name { font-weight: 600; font-size: 14px } .evoke-address { font-size: 12px } .paragraph-section { line-height: 1.3 } .customer_address_section { line-height: 0.5 } .form-section { display: flex; align-items: center; white-space: nowrap; margin-top: -14px; margin-bottom: -14px } .form-label { margin-right: 5px; font-weight: bold } table { border-collapse: collapse } th, td { border: 1px solid black; padding: 1px 4px; text-align: left } .transmission-dates { padding: 3px 5px; font-size: 13px } .text-danger { color: red } .new-page { page-break-before: always } .content-centered { display: flex; justify-content: center } .text-bold { font-weight: bold } .text-underline { text-decoration: underline } .text-italic { font-style: italic } .subject { display: flex; flex-direction: column; align-items: center } .mb-30 { margin-bottom: 30px } .mb-16 { margin-bottom: 16px } .cvma-content { font-size: 10pt } .cvma-paragraph-section { line-height: 1.1 } .d-flex { display: flex; } .justify-content-between { justify-content: space-between; } .text-center{text-align: center;}
`;

export const REVIEW_MODAL_TITLES = {
  process: "Review Reports Before Process",
  unprocess: "Review Reports Before Un-Process",
};

export const ALERT_ACTION_TEXT = {
  "sign-and-process": "signed and processed",
  process: "processed",
};

export const NOTIFICATION_ROUTES = {
  "pending-approvals": "/tasks/pending-approvals",
};

export const RESEND_OTP_COOLDOWN_SECONDS = 60;

export const OTP_REQUEST_LIMIT_EXCEEDED_CODE = "OTP_REQUEST_LIMIT_EXCEEDED";
export const OTP_VALIDATION_ATTEMPT_LIMIT_EXCEEDED_CODE =
  "OTP_VALIDATION_ATTEMPT_LIMIT_EXCEEDED";
export const OTP_BLOCKED_ERROR_CODES = [
  OTP_REQUEST_LIMIT_EXCEEDED_CODE,
  OTP_VALIDATION_ATTEMPT_LIMIT_EXCEEDED_CODE,
];

export const APPROVAL_STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "approved", label: "Approved" },
  { value: "declined", label: "Declined" },
  { value: "pending", label: "Pending" },
];

export const DISCONNECT_HISTORY_VISIBLE_COUNT = 2;

export const TRANSMISSION_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "inOffice", label: "In-Office" },
  { value: "remote", label: "Remote" },
];

export const MONTHLY_BATTERY_CHECK_OPTIONS = [
  { value: "all", label: "All" },
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const ADVISORY_OPTIONS = [
  { value: "all", label: "All" },
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const DISCONNECTED_DATE_ORDER_OPTIONS = [
  { value: "desc", label: "Newest - Oldest" },
  { value: "asc", label: "Oldest - Newest" },
];

export const MOUNTAIN_TIME_ZONE = "America/Denver";

export const OBJECT_URL_REVOKE_DELAY_MS = 60 * 1000;

export const DEFAULT_PROVIDER_NOTES_TITLE = "Provider Notes";
